import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/markyctian/nes-design/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Container, Table } from '@components';
import { Playground } from 'docz';
import { Props } from './config';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const TagVersion = makeShortcode("TagVersion");
const Explain = makeShortcode("Explain");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "container"
    }}>{`Container`}</h2>
    <TagVersion component="Container" mdxType="TagVersion" />
    <h2 {...{
      "id": "use-and-import"
    }}>{`Use and Import`}</h2>
    <Explain component="Container" isCopyable mdxType="Explain" />
    <h2 {...{
      "id": "case"
    }}>{`Case`}</h2>
    <Playground __position={2} __code={'<Container />\n<Container> This is container</Container>\n<Container title=\"Title\"> This is container with a title </Container>'} __scope={{
      props,
      DefaultLayout,
      Container,
      Table,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="container" mdxType="Playground">
  <Container mdxType="Container" />
  <Container mdxType="Container"> This is container</Container>
  <Container title="Title" mdxType="Container"> This is container with a title </Container>
    </Playground>
    <Playground __position={3} __code={'<Container center title=\"Title Center\">\n  <div style={{ display: \'flex\' }}>自定义</div>\n</Container>'} __scope={{
      props,
      DefaultLayout,
      Container,
      Table,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Title Center" mdxType="Playground">
  <Container center title="Title Center" mdxType="Container">
    <div style={{
          display: 'flex'
        }}>自定义</div>
  </Container>
    </Playground>
    <Playground __position={4} __code={'<Container center title=\"Round\" round>\n  round Container\n</Container>'} __scope={{
      props,
      DefaultLayout,
      Container,
      Table,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Round" mdxType="Playground">
  <Container center title="Round" round mdxType="Container">
    round Container
  </Container>
    </Playground>
    <Playground __position={5} __code={'<Container center title=\"Theme\" theme=\"dark\" round>\n  Theme Container\n</Container>\n<Container title=\"Theme\" theme=\"dark\" style={{ marginTop: 20 }}>\n  Theme Container\n</Container>'} __scope={{
      props,
      DefaultLayout,
      Container,
      Table,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Theme" mdxType="Playground">
  <Container center title="Theme" theme="dark" round mdxType="Container">
    Theme Container
  </Container>
  <Container title="Theme" theme="dark" style={{
        marginTop: 20
      }} mdxType="Container">
    Theme Container
  </Container>
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <>
  {[Props.public].map(({
        columns,
        data,
        footer
      }) => <div style={{
        marginTop: 20
      }}>
        <Table theme="dark" columns={columns} data={data} footer={() => <div style={{
          height: 60,
          borderTop: '4px solid white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
              {footer}
            </div>} mdxType="Table" />
      </div>)}
    </>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      